import { GenericService } from './generic-service'

class AuthorsService extends GenericService {
  constructor () {
    super('/autores')
  }
}

export default new AuthorsService()
